import api from './interceptor';

const BASE_URL_V2 = 'api/v2/sso';

export default {
  // API Version 2
  generateSso: clinicId => api.get(`${BASE_URL_V2}/token/${clinicId}/generate`),
};
